import React from 'react';

function Work({ h = 23, w = 24 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={w}
      height={h}
      fill="none"
      viewBox="0 0 24 23"
    >
      <path
        fill="#3AB2EE"
        stroke="#3AB2EE"
        strokeWidth="0.063"
        d="M16.984 4.403v.031H21c.836 0 1.539.288 2.11.862.572.574.859 1.308.859 2.204v4.113c0 .334-.081.579-.238.74-.156.162-.392.245-.715.245h-.032v8.305c0 .54-.2 1.016-.6 1.43-.401.414-.862.62-1.384.62H3c-.522 0-.983-.206-1.384-.62-.4-.414-.6-.89-.6-1.43v-8.305H.984c-.323 0-.56-.084-.715-.245-.157-.161-.238-.406-.238-.74V7.5c0-.896.287-1.63.858-2.204.572-.574 1.275-.862 2.111-.862h4.016V3.34c0-.864.286-1.59.858-2.18.572-.59 1.275-.886 2.11-.886h4.032c.835 0 1.538.295 2.11.886.572.59.858 1.316.858 2.18v1.064zM15 4.434h.031V3.34c0-.298-.096-.548-.29-.748a.97.97 0 00-.725-.3H9.984a.97.97 0 00-.725.3c-.194.2-.29.45-.29.748v1.095H15zM2.969 20.904v.03H21.03v-8.336H14.97v3.128a2.01 2.01 0 01-.577 1.454 1.884 1.884 0 01-1.408.595h-1.968a1.884 1.884 0 01-1.408-.595 2.01 2.01 0 01-.577-1.454v-3.128H2.97v8.305zm8.015-5.178v.031h2.032V12.598h-2.032v3.128zm11-5.098h.032V7.5c0-.36-.083-.634-.255-.82-.172-.185-.427-.276-.761-.276H3c-.334 0-.59.09-.761.276-.172.186-.255.46-.255.82v3.128h20z"
      ></path>
    </svg>
  );
}

export default Work;
